import { render } from "./TheVideoViewer.vue?vue&type=template&id=0d937911&scoped=true&ts=true"
import script from "./TheVideoViewer.vue?vue&type=script&lang=ts"
export * from "./TheVideoViewer.vue?vue&type=script&lang=ts"

import "./TheVideoViewer.vue?vue&type=style&index=0&id=0d937911&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d937911"]])

export default __exports__